//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


import { PosClientBase, PosClientConfig, throwException } from './base';
import type { FileParameter, FileResponse, ProblemDetails, ReachProSupportCaseAttachmentResponse, ReachProSupportCaseInboxResponse, ReachProSupportCaseLookupResponse, ReachProSupportCaseNoteResponse, ReachProSupportCaseResponse, SubmitNoteFeedbackRequest } from './types';


export interface IReachProSupportCaseClient {

    getSupportCases(offset: number | undefined, pageSize: number | undefined): Promise<ReachProSupportCaseInboxResponse>;

    getExistingSupportCase(listingId: number | null | undefined, saleId: number | null | undefined): Promise<ReachProSupportCaseLookupResponse>;

    getSupportCaseNotes(workItemId: number | undefined): Promise<ReachProSupportCaseNoteResponse[]>;

    getSupportCase(workItemId: number | undefined): Promise<ReachProSupportCaseResponse>;

    createSupportCase(topic: string | null | undefined, eventId: number | undefined, listingId: number | null | undefined, saleId: number | null | undefined, attachments: FileParameter[] | null | undefined): Promise<ReachProSupportCaseResponse>;

    addSupportCaseNote(workItemId: number | undefined, messageContent: string | null | undefined, attachments: FileParameter[] | null | undefined): Promise<ReachProSupportCaseNoteResponse>;

    getSupportCaseAttachments(workItemId: number | undefined): Promise<ReachProSupportCaseAttachmentResponse[]>;

    getSupportCaseAttachment(workItemId: number | undefined, documentId: string | undefined): Promise<FileResponse>;

    submitNoteFeedback(request: SubmitNoteFeedbackRequest): Promise<void>;
}

export class ReachProSupportCaseClient extends PosClientBase implements IReachProSupportCaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: PosClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSupportCases(offset: number | undefined, pageSize: number | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseInboxResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCases?";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCases(_response);
        });
    }

    protected processGetSupportCases(response: Response): Promise<ReachProSupportCaseInboxResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseInboxResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseInboxResponse>(null as any);
    }

    getExistingSupportCase(listingId: number | null | undefined, saleId: number | null | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseLookupResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetExistingSupportCase?";
        if (listingId !== undefined && listingId !== null)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&";
        if (saleId !== undefined && saleId !== null)
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExistingSupportCase(_response);
        });
    }

    protected processGetExistingSupportCase(response: Response): Promise<ReachProSupportCaseLookupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseLookupResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseLookupResponse>(null as any);
    }

    getSupportCaseNotes(workItemId: number | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseNoteResponse[]> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCaseNotes?";
        if (workItemId === null)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else if (workItemId !== undefined)
            url_ += "workItemId=" + encodeURIComponent("" + workItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCaseNotes(_response);
        });
    }

    protected processGetSupportCaseNotes(response: Response): Promise<ReachProSupportCaseNoteResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseNoteResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseNoteResponse[]>(null as any);
    }

    getSupportCase(workItemId: number | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCase?";
        if (workItemId === null)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else if (workItemId !== undefined)
            url_ += "workItemId=" + encodeURIComponent("" + workItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCase(_response);
        });
    }

    protected processGetSupportCase(response: Response): Promise<ReachProSupportCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseResponse>(null as any);
    }

    createSupportCase(topic: string | null | undefined, eventId: number | undefined, listingId: number | null | undefined, saleId: number | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/CreateSupportCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (topic !== null && topic !== undefined)
            content_.append("Topic", topic.toString());
        if (eventId === null || eventId === undefined)
            throw new Error("The parameter 'eventId' cannot be null.");
        else
            content_.append("EventId", eventId.toString());
        if (listingId !== null && listingId !== undefined)
            content_.append("ListingId", listingId.toString());
        if (saleId !== null && saleId !== undefined)
            content_.append("SaleId", saleId.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSupportCase(_response);
        });
    }

    protected processCreateSupportCase(response: Response): Promise<ReachProSupportCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseResponse>(null as any);
    }

    addSupportCaseNote(workItemId: number | undefined, messageContent: string | null | undefined, attachments: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseNoteResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/AddSupportCaseNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (workItemId === null || workItemId === undefined)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else
            content_.append("WorkItemId", workItemId.toString());
        if (messageContent !== null && messageContent !== undefined)
            content_.append("MessageContent", messageContent.toString());
        if (attachments !== null && attachments !== undefined)
            attachments.forEach(item_ => content_.append("Attachments", item_.data, item_.fileName ? item_.fileName : "Attachments") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddSupportCaseNote(_response);
        });
    }

    protected processAddSupportCaseNote(response: Response): Promise<ReachProSupportCaseNoteResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseNoteResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseNoteResponse>(null as any);
    }

    getSupportCaseAttachments(workItemId: number | undefined, signal?: AbortSignal | undefined): Promise<ReachProSupportCaseAttachmentResponse[]> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCaseAttachments?";
        if (workItemId === null)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else if (workItemId !== undefined)
            url_ += "workItemId=" + encodeURIComponent("" + workItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCaseAttachments(_response);
        });
    }

    protected processGetSupportCaseAttachments(response: Response): Promise<ReachProSupportCaseAttachmentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReachProSupportCaseAttachmentResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReachProSupportCaseAttachmentResponse[]>(null as any);
    }

    getSupportCaseAttachment(workItemId: number | undefined, documentId: string | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/GetSupportCaseAttachment?";
        if (workItemId === null)
            throw new Error("The parameter 'workItemId' cannot be null.");
        else if (workItemId !== undefined)
            url_ += "workItemId=" + encodeURIComponent("" + workItemId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportCaseAttachment(_response);
        });
    }

    protected processGetSupportCaseAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    submitNoteFeedback(request: SubmitNoteFeedbackRequest, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ReachProSupportCase/SubmitNoteFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitNoteFeedback(_response);
        });
    }

    protected processSubmitNoteFeedback(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}
